import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { IconsModule } from '@shared/icons/icons.module';

import {
  DocumentAddOtherComponent,
  DocumentBrowseButtonComponent,
  DocumentDetailsComponent,
  DocumentFormImportComponent,
  DocumentMobilePlaceholderComponent,
  DocumentPreviewBoxComponent,
  DocumentsPreviewModalComponent,
  DocumentUploadDesktopComponent,
  DocumentUploadImageComponent,
  DocumentUploadLogoComponent,
  DocumentUploadMultiplePlaceholderComponent,
  DocumentUploadOcrComponent,
  DocumentUploadPlaceholderComponent,
  DocumentUploadPreviewComponent,
} from './components';

import { RouterModule } from '@angular/router';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { CustomTooltipModule } from '@shared/tooltip/custom-tooltip.module';
import { MutualModule } from '@shared/mutual/mutual.module';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { CustomToastModule } from '@shared/custom-toast/custom-toast.module';

@NgModule({
  declarations: [
    DocumentAddOtherComponent,
    DocumentUploadImageComponent,
    DocumentDetailsComponent,
    DocumentUploadDesktopComponent,
    DocumentFormImportComponent,
    DocumentUploadLogoComponent,
    DocumentUploadPlaceholderComponent,
    DocumentUploadMultiplePlaceholderComponent,
    DocumentUploadOcrComponent,
    DocumentMobilePlaceholderComponent,
    DocumentUploadPreviewComponent,
    DocumentBrowseButtonComponent,
    DocumentPreviewBoxComponent,
    DocumentsPreviewModalComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    CustomModalModule,
    FormWrapperModule,
    IconsModule,

    RouterModule,
    PipesSharedModule,
    CustomTooltipModule,
    CustomToastModule,
    MutualModule,
    NzPopoverModule,
    NzToolTipModule,
  ],
  exports: [
    DocumentAddOtherComponent,
    DocumentUploadImageComponent,
    DocumentDetailsComponent,
    DocumentUploadDesktopComponent,
    DocumentFormImportComponent,
    DocumentUploadLogoComponent,
    DocumentUploadPlaceholderComponent,
    DocumentUploadMultiplePlaceholderComponent,
    DocumentUploadOcrComponent,
    DocumentMobilePlaceholderComponent,
    DocumentUploadPreviewComponent,
    DocumentBrowseButtonComponent,
    DocumentPreviewBoxComponent,
    DocumentsPreviewModalComponent,
  ],
})
export class DocumentModule {}
